import { useEffect, useState } from 'react';
import { Dropdown, Nav } from 'react-bootstrap';
import { RouteItems, routes } from 'sitemap';
import TopNavMegaMenu from './TopNavMegaMenu';
import TopNavItem from './TopNavItem';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter, checkAccess } from 'utils/helpers';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { antrag } from 'utils/enums/misc';

const NavbarTopNav = () => {
  const userPermission = useSelector(
    (state: RootState) => state.userProfile.permission
  );
  return (
    <Nav className="navbar-nav-top pb-4 pb-lg-0 scrollbar" id="top-navbar">
      {routes.map((route, i) => (
        <ConditionalRender
          condition={
            !route.permission || checkAccess([route.permission], userPermission)
          }
          fallBack={null}
          key={`navbar-top-${i}`}
        >
          <ConditionalRender
            condition={
              !route.notShowInProd ||
              process.env.REACT_APP_SUB_DOMAIN !== 'antrag'
            }
          >
            <NavbarTopNavItem route={route} key={route.label} />
          </ConditionalRender>
        </ConditionalRender>
      ))}
    </Nav>
  );
};

const NavbarTopNavItem = ({ route }: { route: RouteItems }) => {
  const navigate = useNavigate();
  const Icon = route.icon;
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const path = route.path;
  const { breakpoints } = useBreakpoints();

  const handleMouseEnter = () => {
    if (breakpoints.up('lg')) {
      setShow(true);
    }
  };

  const handleMouseLeave = () => {
    if (breakpoints.up('lg')) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (show) {
      setShow(false);
    }
  }, [pathname]);

  const handleClick = () => {
    if (path) {
      navigate(path);
    }
  };

  const isActivePath = (): boolean => {
    if (route.hasPages) {
      return route.pages.some(page => {
        return page.path === `${pathname}` || page.path === path;
      });
    }
    if (!path) return false;
    return (
      `/${pathname.split('/').pop()}` === path ||
      pathname.split('/').includes(path.replace('/', ''))
    );
  };

  return (
    <Dropdown
      as="li"
      show={route.hasPages ? show : false}
      className="nav-item"
      key={route.label}
      autoClose="outside"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onToggle={() => setShow(!show)}
      onClick={() => setShow(!show)}
      id="top-nav-item"
    >
      <Dropdown.Toggle
        as="div"
        variant=""
        className={`nav-link lh-1 d-flex hover-navigation align-items-center cursor-pointer ${
          isActivePath() ? 'active text-danger' : ''
        } `}
        onClick={e => {
          if (path) {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        <ConditionalRender
          condition={route.iconSet === 'svg'}
          fallBack={<Icon className="me-2" size={16} />}
        >
          <Icon className="me-2" size={16} height={16} width={16} />
        </ConditionalRender>
        <span>
          {route.label === 'FAQ'
            ? route.label
            : capitalizeFirstLetter(
                route.horizontalNavLabel
                  ? route.horizontalNavLabel
                  : route.label
              )}
        </span>
      </Dropdown.Toggle>
      {route.megaMenu ? (
        <TopNavMegaMenu route={route} />
      ) : (
        <TopNavItem route={route} />
      )}
    </Dropdown>
  );
};

export default NavbarTopNav;
